// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    name: 'Walden', 
    assetBaseUrl:'https://genaichatbotqa.blob.core.windows.net/chatbots/',
    oktaAuthService:'oidc.okta',
    clientId:'0oa2342v06zO3TrHA0h8',
    issuer:'https://atge.oktapreview.com',
    // redirectUri:'http://localhost:4200/login/callback',
    redirectUri:'https://genai-qa.waldenu.edu/login/callback',
    oktaSignoutRedirectUri: 'https://genai-qa.waldenu.edu',
    studentAzureChatBotServiceFlag:true,
    studentGCPChatBotServiceFlag:true,
    studentAvaamoChatBotServiceFlag:true,
    chatbotName:'Charlotte',
    EnrollmentChatbotName: 'Enrollment Co-pilot',
    SASTokenForUnivercityLogo: 'sp=r&st=2024-11-19T13:34:53Z&se=2026-08-31T21:34:53Z&sv=2022-11-02&sr=b&sig=%2FHbHInnC4w%2BCxT32wm4H9%2Buix5x0VEj%2FaKYk7Vd6ab0%3D',
    SASTokenForChatbotIcon: 'sp=r&st=2024-11-18T14:21:23Z&se=2026-08-31T22:21:23Z&sv=2022-11-02&sr=b&sig=sq1rO%2BVz9Xa4Ki1Yg%2FwzNVvRVRVzszqE5VEW11WVIac%3D',
    SASTokenForFavicon: 'sp=r&st=2024-10-17T11:46:06Z&se=2026-05-31T19:46:06Z&sv=2022-11-02&sr=b&sig=bFOxUZWgVlNULsXokpoJaqvM%2BVVADeLa2INNGYiYNl4%3D',
    SASTokenForSudentAzureBot: 'sp=r&st=2024-11-29T12:57:55Z&se=2026-09-30T20:57:55Z&sv=2022-11-02&sr=b&sig=yIPi6fpdMzcrFkLPlCiGj2QGOQEAA9oo7p52FkEAqMo%3D',
    studentChatbotName: 'Avaamo chat Bot',
    chatbotIconForMessage: 'sp=r&st=2024-11-18T14:09:23Z&se=2026-08-31T22:09:23Z&sv=2022-11-02&sr=b&sig=BgN9mQaAporgBnDMfRFoxE8ZfX4g3x1N9M7IgmOYLqM%3D',
    SASTokenForLogoutButton: 'sp=r&st=2024-12-04T08:51:26Z&se=2026-11-01T16:51:26Z&sv=2022-11-02&sr=b&sig=78rZPFnnhjWYYkHB5D5RC96YWZH3%2F2SuONsVGHA2SRw%3D',
    apimConfigurationEnable: true,
    enrollmentRouteName: 'enrollmentcopilot',
    studentAzureRouteName: 'student-support-azure',
    studentbotRouteName: 'studentbot',
    faqConfigurationEnable: true,

    studentAsStaffConfig: {
      apimSubscriptionKeyForStd: 'a75ed9a5762b47e7a81b7b36a34c6953',
      botApiUrl: "https://bis-api-dot-app-studentportal-qa.ue.r.appspot.com/staffassistantqa/token",
      chatUrl: 'https://charlotte-microapp-qa.web.app/assets/js/chatbot.js',
      channelId: 'c22c5904-1fca-4db3-84f2-925ae85d6506',
      cachedResponseConstant: 'Saved Student Response',
      chatBotIdStd: "",
      secretKey: "",
    },
    enrollmentConfig: {
      apimSubscriptionKeyForEnr: '6754180899284073b9869711f1157ac1',
      cachedResponseConstant: 'Saved Enrollment Response',
      chatBotIdEnr: "",
      salesforceConfigUrl:"https://laureateone--fsb.sandbox.lightning.force.com",
    },

    commonConfig: {
      acknowledgementAPI: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/acknowledgement_api/",
      chatHistory: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/get_chat_history_api/",
      citationPDF: "https://genaicopilotmmpqablob.blob.core.windows.net/",
      citationPayloadLink: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/citation_category_group_api/",
      convoAction: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/convo_action/",
      convoFeedback: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/convo_feedback/",
      // getAuthToken: "https://genai-admin-qa.waldenu.edu/get_token/",
      getChatbotId: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/get_chatbot_id/",
      refreshChat: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/clear_history_api/",
      sasCookies: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/create_user_delegation_sas_container/",
      sasToken: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/create_user_delegation_sas_container/",
      searchApiRequest: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/search_api_request/",
      faqApi: "https://api-qa.waldenu.edu/genai/wu/chat/1.0/get_faq_for_categories/",
      publicKey: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUFxdzlIZkttaDgzdmtvTWd3ekxVdgpuMCtlWlo3Y1JTdmdEbTVsWXFIbDFveUF6dUN6ak1NcitvcW5LMUVwSXI2T3dBcnREL3BNQVZaWS9ybDBvNkE0CjF6Vms2QWVwRW9wZ2svMDhHcFVtaDZTZ01leWcreGM5TDFHNlpMWGRqNXpXZ3AwdVIvbFNTSWN6QXNQYld0enAKSXN3bGVMUm95U29lUFhkUEkxbElhaE9JU0o1N095Y0QwZ01MU1RDVEl2WGhMTVluUGNDS1FWYjRVaE53cjI2MQpGd2dVNm5xSWlEY2JPWW1vWjN5bXdyM3FXVTdQZGpMc2Y0aCtNYnRNYjkvVGZCZmRGUkpNSy9LWWs3dldNbGZXCkpyY3g5VGlKblRIV3FORnQxQXZIcmtTQnlVbzJaTFE3Mm5Uck9SYzM0MlR1V3QzRkJkZU1hZ2hjOVlxR3pycVUKUHdJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
      getFunctionKeyValidation: "https://genai-admin-qa.waldenu.edu/get_token/",
      functionKey: 'OowNuSYuHX1RnfalZsr5UB1DFYYs0-uYV6AYIA9tzmIfAzFuv907rQ==',
    }, 
    
      Question1:"What support services are available for Walden students?",
      Question2:"How is Walden's faculty different from other online universities?",
      Question3:"Can you tell me about Walden's accreditation?"
};

(window as any).env = environment;
